import Header from 'components/headers/bulletins'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Switch from 'react-switch'
import { RootState } from 'store/redux'
import { toggleSendMessage, toggleTransparency } from 'store/redux/moneyPoolBox'
export default function SendMessages() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const [checked, setChecked] = useState<{ [key: string]: boolean }>({
        sendMessageLoanToOthers:
            store?.sendMessageLoanToOthers !== undefined
                ? store?.sendMessageLoanToOthers
                : false,
        sendMessageRememberMemberShip:
            store?.sendMessageRememberMemberShip !== undefined
                ? store?.sendMessageRememberMemberShip
                : false,
        sendMessageRememberLoan:
            store?.sendMessageRememberLoan !== undefined
                ? store?.sendMessageRememberLoan
                : false,
        sendMessageDepositToManager:
            store?.sendMessageDepositToManager !== undefined
                ? store?.sendMessageDepositToManager
                : false,
        sendPushNotificationToOthers:
            store?.sendPushNotificationToOthers !== undefined
                ? store?.sendPushNotificationToOthers
                : true,
        sendPushNotificationToAllMembers:
            store?.sendPushNotificationToAllMembers !== undefined
                ? store?.sendPushNotificationToAllMembers
                : true,
    })
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleChangeChecked = (value: string) => {
        const newChecked = { ...checked }
        newChecked[value] = !newChecked[value]
        setChecked(newChecked)
    }

    return (
        <div className="  flex flex-col bg-white h-full">
            <div className=" grow-0">
                <Header title="تنظیمات صندوق" />
            </div>
            <div className=" grow px-2">
                <p className=" text-lg my-2">شفافیت ارسال اعلان‌های صندوق</p>
                <hr className=" my-3" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال پیامک اعطای وام به تمامی اعضا
                    </p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('sendMessageLoanToOthers')
                        }
                        checked={checked.sendMessageLoanToOthers}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، در صورت اعطای وام، پیامکی برای تمامی
                    اعضای صندوق ارسال می‌شود که شامل مبلغ وام و نام وام‌گیرنده است.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال پیامک یادآوری پرداخت حق‌عضویت
                    </p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('sendMessageRememberMemberShip')
                        }
                        checked={checked.sendMessageRememberMemberShip}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، برای عضوی که تا سه روز قبل از سررسید
                    صندوق، حق‌عضویت خود را پرداخت نکرده، پیامک یادآوری پرداخت
                    ارسال می‌شود.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال پیامک یادآوری پرداخت قسط وام
                    </p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('sendMessageRememberLoan')
                        }
                        checked={checked.sendMessageRememberLoan}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، برای عضوی که تا سه روز قبل از موعد قسطش،
                    قسط خود را پرداخت نکرده، پیامک یادآوری پرداخت ارسال می‌شود.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">ارسال پیامک واریزی به مدیر</p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('sendMessageDepositToManager')
                        }
                        checked={checked.sendMessageDepositToManager}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، هرگاه هر یک از اعضا، واریز وجه داشته
                    باشد، پیامک اطلاع‌رسانی برای مدیران صندوق ارسال خواهد شد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        پیام درون‌برنامه‌ای اعطای وام به تمامی اعضا
                    </p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('sendPushNotificationToOthers')
                        }
                        checked={checked.sendPushNotificationToOthers}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، در صورت اعطای وام، پیامی برای تمامی
                    اعضای صندوق ارسال می‌شود که شامل مبلغ وام و نام وام‌گیرنده است.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        ارسال نوتیفیکشن اعطای وام به تمامی اعضا
                    </p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked(
                                'sendPushNotificationToAllMembers'
                            )
                        }
                        checked={checked.sendPushNotificationToAllMembers}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، در صورت اعطای وام، یک نوتیفیکشن
                    برای تمامی اعضای صندوق ارسال خواهد شد که شامل مبلغ وام و
                    نام وام‌گیرنده است.
                </p>
            </div>
            <div className=" grow-0">
                <div className=" bg-white py-4 px-4">
                    <button
                        className=" w-full bg-green-1 rounded-2xl text-white py-3"
                        onClick={() => {
                            dispatch(
                                toggleSendMessage({
                                    sendMessageLoanToOthers:
                                        checked.sendMessageLoanToOthers,
                                    sendMessageRememberMemberShip:
                                        checked.sendMessageRememberMemberShip,
                                    sendMessageRememberLoan:
                                        checked.sendMessageRememberLoan,
                                    sendMessageDepositToManager:
                                        checked.sendMessageDepositToManager,
                                    sendPushNotificationToOthers:
                                        checked.sendPushNotificationToOthers,
                                    sendPushNotificationToAllMembers:
                                        checked.sendPushNotificationToAllMembers,
                                })
                            )
                            navigate(-1)
                        }}
                    >
                        ثبت تغییرات
                    </button>
                </div>
            </div>
        </div>
    )
}
